import React from 'react';
import { Dialog, DialogContent, IconButton, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { PropertySearchListModel } from 'app/modules/main/api/main-clients.api';
import { ResultItemCard } from './result-item';

interface PropertyPopupProps {
    open: boolean;
    onClose: () => void;
    property: PropertySearchListModel | null;
}

export default function PropertyPopup({ open, onClose, property }: PropertyPopupProps) {
    if (!property) return null;

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 2,
                    maxHeight: '90vh',
                    overflow: 'hidden'
                }
            }}
        >
            <DialogContent sx={{ p: 0, position: 'relative' }}>
                {/* Close button */}
                <IconButton
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        top: 8,
                        right: 8,
                        zIndex: 1,
                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                        '&:hover': {
                            backgroundColor: 'rgba(255, 255, 255, 1)',
                        }
                    }}
                    size="small"
                >
                    <CloseIcon />
                </IconButton>

                {/* Property card content */}
                <Box sx={{ p: 2 }}>
                    <ResultItemCard item={property} />
                </Box>
            </DialogContent>
        </Dialog>
    );
}
